export class Accordion {

    constructor() {
        this.service_accordion();
    }
    service_accordion () {
        jQuery(".accordion-button").on("click", function() {
            if(jQuery(this).hasClass("collapsed")) { // Sto richiudendo la tab
                jQuery(".service-col-right").html("").hide();
                jQuery(".service-col-right").removeClass("active");
            } else { // Espandi contenuto sulla colonna di destra
                let id_to_clone = jQuery(this).attr("aria-controls");
                let accordion_body = jQuery("#" + id_to_clone).find(".accordion-body").html();
                jQuery(".service-col-right").hide().html(accordion_body).fadeIn(500);
                jQuery(".service-col-right").addClass("active");
            }
        });

        jQuery(function () {
            const mq = window.matchMedia("(min-width: 767.98px)");
            function handleChange(e) {
                if (e.matches) { // Visualizzazione desktop
                    jQuery(".accordion-body").hide();
                } else {
                    jQuery(".accordion-body").show();
                }
            }
            handleChange(mq); // Controllo iniziale
            mq.addEventListener("change", handleChange); // Controllo al resize della finestra
        });

    }

}